import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { medicalExamination } from '../../../../model/medicalexamination';
import { notifActionCreator } from '../../notification/actions/creators';

export interface IActions {
    loadMedicalExaminationsToBeValidate: () => Promise<Array<medicalExamination>>;
    validateMedicalExamination: (userid: string, mex: medicalExamination) => void;
    addMedicalExamination: (sub: string, mex: medicalExamination) => Promise<medicalExamination>;
    deleteMedicalExamination: (userid: string, mex: medicalExamination) => void;
    resetNewMedicalExamination: () => void;
    loadMedicalExaminationsByUser: (sub: string) => Promise<Array<medicalExamination>>;
    loadMedicalExaminationsByMexId: (sub: string, documentId: string) => Promise<medicalExamination>;
}

// function parseQueryStringParameters(yyyymmdd?: string, page?: number, take?: number) {
//     let parsed = ``
//     if (yyyymmdd) {
//         parsed = parsed.concat(`?`);
//         if (yyyymmdd) {
//             parsed = parsed.concat(`yyyymmdd=${yyyymmdd}`);
//         }
//     }
//     return parsed;
// }

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadMedicalExaminationsToBeValidate: () => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOAD,
                    payload: invokeApi({
                        path: '/api/MedicalExamination/admin/documents/tobevalidated',
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        validateMedicalExamination: (sub: string, mex: medicalExamination) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.VALIDATE,
                    payload: invokeApi({
                        path: `/api/Contact/${sub}/MedicalExamination/admin/document`,
                        method: 'PUT',
                        body: mex,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        notifActionCreator(dispatch).setSaveNotification({ result: true, message: "Documento visita medica aggiornato" });
                        return resp;
                    }).catch((error: any) => {
                        notifActionCreator(dispatch).setSaveNotification({ result: false, message: error.message });
                    })
                })
            });
        },
        addMedicalExamination: (sub: string, mex: medicalExamination) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.ADD,
                    payload: invokeApi({
                        path: `/api/Contact/${sub}/MedicalExamination/admin/document`,
                        method: 'POST',
                        body: mex,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        notifActionCreator(dispatch).setSaveNotification({ result: true, message: "Documento visita medica caricato" });
                        return resp;
                    }).catch((error: any) => {
                        notifActionCreator(dispatch).setSaveNotification({ result: false, message: error.message });
                    })
                })
            });
        },
        deleteMedicalExamination: (sub: string, mex: medicalExamination) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.DELETE,
                    payload: invokeApi({
                        path: `/api/Contact/${sub}/MedicalExamination/admin/document`,
                        method: 'DELETE',
                        body: mex,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        notifActionCreator(dispatch).setSaveNotification({ result: true, message: "Documento visita medica eliminato" });
                        return resp;
                    }).catch((error: any) => {
                        notifActionCreator(dispatch).setSaveNotification({ result: false, message: error.message });
                    })
                })
            });
        },
        resetNewMedicalExamination: () => {
            dispatch({
                type: Keys.RESETNEW,
            })
        },
        loadMedicalExaminationsByMexId: (sub: string, documentId: string) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADBYMEX_ID,
                    payload: invokeApi({
                        path: `/api/Contact/${sub}/MedicalExamination/document/${documentId}`,
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        loadMedicalExaminationsByUser: (sub: string) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADBYUSER,
                    payload: invokeApi({
                        path: `/api/Contact/${sub}/MedicalExamination/admin/documents`,
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
    }
}